<template>
  <div id="NetEnvTest">
    <el-row class="top-title">
      <el-col :span="24" class="top-title">
        <h2>系统环境配置检测</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="testItem" label="测试项"></el-table-column>
        <el-table-column label="测试结果">
          <template slot-scope="scope">
            <span v-if="scope.tips != '正在检测...'">
              <i class="el-icon-circle-check success" v-if="scope.row.flag"></i>
              <i class="el-icon-circle-close failure" v-else></i>
            </span>
            <span v-html="scope.row.tips"></span>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import {
  OSInfo,
  browserInfo,
  checkScreen,
  getFlashVersion,
  getCookieEnable
} from '../plugins/utils'

export default {
  name: 'VodEnvTest',
  data() {
    return {
      inTesting: '正在检测...',
      tableData: [
        {
          testItem: '操作系统',
          tips: '正在检测...'
        },
        {
          testItem: '浏览器版本',
          tips: '正在检测...'
        },
        {
          testItem: '屏幕分辨率',
          tips: '正在检测...'
        },
        // {
        //   testItem: 'Flash1 Player',
        //   tips: '正在检测...'
        // },
        {
          testItem: '浏览器Cookie',
          tips: '<span>未开启浏览器Cookie，部分功能无法使用</span>'
        },
        {
          testItem: '浏览器JavaScript',
          tips: '正在检测...'
        }
      ]
    }
  },
  methods: {
    testFlash(index) {
      // Flash检测
      var flash = getFlashVersion()
      var tips =
        '<span>请设置开启或</span><a href="http://get.adobe.com/cn/flashplayer/">点击安装</a>'
      if (flash.flash === 0) {
        this.tableData[index].tips = '浏览器Flash被禁用/未安装 ' + tips
        this.tableData[index].flag = false
      } else if (flash.vaild === 0 || flash.version < 11) {
        this.tableData[index].tips = 'Flash过期 ' + tips
        this.tableData[index].flag = false
      } else {
        this.tableData[index].tips = 'Flash ' + flash.version
        this.tableData[index].flag = true
      }
    },
    sysTest(index) {
      // OS检测
      var os = OSInfo()
      this.tableData[index].tips = os.os + ' ' + os.osVersion
      this.tableData[index].flag = true
    },
    browserTest(index) {
      // 浏览器检测
      var browser = browserInfo()
      this.tableData[index].tips = browser.browser + ' ' + browser.version
      this.tableData[index].flag = true
      return {
        mobile: browser.mobile
      }
    },
    screenTest(index) {
      // 分辨率
      this.tableData[index].tips = checkScreen()
      this.tableData[index].flag = true
    },
    cookieTest(index) {
      // cookie
      if (getCookieEnable()) {
        this.tableData[index].tips = '已启用'
        this.tableData[index].flag = true
      } else {
        this.tableData[index].result = '未启用'
        this.tableData[index].flag = false
      }
    },
    jsTest(index) {
      // javascript
      this.tableData[index].tips = '已启用'
      this.tableData[index].flag = true
    }
  },
  created() {
    this.browserTest(1)
    // if (!mobile.mobile) {
    //   // Flash检测
    //   this.testFlash(3)
    // } else {
    //   this.tableData[3].tips = '移动端'
    //   this.tableData[3].flag = true
    // }
    this.sysTest(0)
    this.screenTest(2)
    this.cookieTest(3)
    this.jsTest(4)
  }
}
</script>
<style>
h2 {
  color: white;
}
.success {
  color: #67c23a;
  font-size: 25px;
}
.failure {
  color: red;
  font-size: 25px;
}</style
>>
